import type { FormatterMap, ProductRoutesOptions, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
  productListFormatter,
} from '@grandvisionhq/www-next/formatters'

const productRoutesOptions: ProductRoutesOptions = {
  'contact-lenses': 'lentes-de-contacto',
  frames: 'gafas-graduadas',
  'ready-readers': 'gafas-de-lectura',
  solutions: 'lentes-de-contacto/liquidos',
  sunglasses: 'gafas-de-sol',
  accessories: 'accesorios',
}

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),

  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('pide-tu-cita'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createAuthFormatters(),
  ...createMyAccountFormatters(),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  'express.checkout.login': createSimpleFormatter('express-user-checkout'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { shipping: 'envio', overview: 'resumen', payment: 'pago' },
  }),
  ...productListFormatter(productRoutesOptions),
  ...productDetailFormatters(productRoutesOptions),
  returns: createSimpleFormatter('/devoluciones'),
  'returns.select-items': createSimpleFormatter('/devoluciones/seleccionar-articulos'),
  'returns.confirmation': createSimpleFormatter('/devoluciones/confirmacion'),
  wishlist: createSimpleFormatter('/wishlist'),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/envio', 'checkout.shipping'],
  ['/checkout/resumen', 'checkout.overview'],
  ['/checkout/pago', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/express-checkout', 'express-checkout'],

  ['/pide-tu-cita{/*path}', 'appointments.book'],
  ['/cancela-tu-cita', 'appointments.cancel'],
  ['/reprograma-tu-cita', 'appointments.reschedule'],
]
